<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra pb-5">
    <div class="row ps-3 pt-4">
      <div class="col">
        <p> <span class="fw-bold">Integrasi</span> - Cetak Draf </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila masukkan TIN atau Tarikh Muat Naik.</p>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col-2 mx-5">
        <input type="number" class="form-control border-0 shadow" placeholder="TIN" [(ngModel)]="InputTaxRefNum" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-6 offset-2">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(InputTaxRefNum)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="Semula()">Semula</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="ViewAll()">Papar Semua</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-3">
      <div class="mx-5 mt-3 col-2">
        <p class="text-center">ATAU</p>
      </div>
    </div>
    <div class="row">
      <div class="col-2 mx-5">
        <input type="text" id="startdate" class="form-control border-0 shadow" placeholder="Tarikh Daftar Mula" autocomplete="off">
      </div>
      <div class="col-2">
        <input type="text" id="enddate" class="form-control border-0 shadow" placeholder="Tarikh Daftar Hingga" autocomplete="off">
      </div>
    </div>
    <div class="bg-white mx-5" *ngIf="SearchStatus">
      <div class="pt-5">
        <p>Senarai e-DTS</p>
      </div>
      <div class="example-table-container">
        <table mat-table [dataSource]="dataSource" class="w-100 shadow">
          <ng-container matColumnDef="taxpayername">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taxpName}}</td>
          </ng-container>
          <ng-container matColumnDef="tin">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.clientId}}</td>
          </ng-container>
          <ng-container matColumnDef="formtype">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.jenisBorangTahun}}</td>
          </ng-container>
          <ng-container matColumnDef="staffname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Staff</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
          </ng-container>
          <ng-container matColumnDef="agentname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taname}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2" *ngIf="res.downloadDraftAccess">
                  <button type="button" (click)="Download(res.drafURL)" class="btn sec-button border-0 shadow rounded-2" role="button">Cetak Draf</button>
                </div>
                <div *ngIf="res.downloadRTKAccess">
                  <button type="button" (click)="Download(res.rkturl)" class="btn sec-button border-0 shadow rounded-2" role="button">Cetak RTK</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
        </mat-paginator>
      </div>
    </div>
  </div>

</div>

